/**
 * @fileoverview GET handler for the "/:app_group_id/knowledge_source/definitions" endpoint
 */
import fetch from "@lib/fetch";
import type { Queries } from "@lib/serializeQueryObjects";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { knowledgeSourceDefinitions } from "./constants";
import type { KnowledgeSourceDefinitionsParams, KnowledgeSourceDefinitionsResult } from "./types";
import { isKnowledgeSourceDefinitionsResult } from "./validators";

export const getDataTableKnowledgeSourceDefinitions = reactQueryTableFetcherAdapter(
  knowledgeSourceDefinitions,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
      status,
    }: KnowledgeSourceDefinitionsParams
  ): Promise<KnowledgeSourceDefinitionsResult> => {
    return fetch(
      `/${appGroupId}/knowledge_source/definitions`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        status,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query as Queries),
      },
      { signal }
    );
  },
  isKnowledgeSourceDefinitionsResult
);
